import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createTextVNode(" This plugin assumes your compound(s) and protein(s) have already been properly protonated. If necessary, be sure to use ");
const _hoisted_2 = /*#__PURE__*/ _createTextVNode(" and ");
const _hoisted_3 = /*#__PURE__*/ _createTextVNode(" first. ");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PluginPathLink = _resolveComponent("PluginPathLink");
    const _component_Alert = _resolveComponent("Alert");
    const _component_PluginComponent = _resolveComponent("PluginComponent");
    return (_openBlock(), _createBlock(_component_PluginComponent, {
        modelValue: _ctx.open,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.open) = $event)),
        infoPayload: _ctx.infoPayload,
        onOnPopupDone: _ctx.onPopupDone,
        actionBtnTxt: "Dock",
        onOnUserArgChanged: _ctx.onUserArgChanged,
        hideIfDisabled: true
    }, {
        default: _withCtx(() => [
            _createVNode(_component_Alert, { type: "warning" }, {
                default: _withCtx(() => [
                    _hoisted_1,
                    _createVNode(_component_PluginPathLink, { plugin: "protonatecomps" }),
                    _hoisted_2,
                    _createVNode(_component_PluginPathLink, { plugin: "reduce" }),
                    _hoisted_3
                ]),
                _: 1
            })
        ]),
        _: 1
    }, 8, ["modelValue", "infoPayload", "onOnPopupDone", "onOnUserArgChanged"]));
}
